const CARRIER_SUPPORT_CONTACTS = {
    "j-link": {phone: "1-800-000-0001", email: "support@j-link.com"},
    csa: {phone: "1-800-000-0002", email: "support@csaltl.com"},
    purolator: {phone: "1-800-000-0003", email: "support@purolator.com"},
    dayandross: {phone: "1-800-000-0004", email: "support@dayandross.com"},
    vitran: {phone: "1-800-000-0005", email: "support@vitran.com"},
    tforce: {phone: "1-800-000-0006", email: "support@tforce.com"},
    bison: {phone: "1-800-000-0007", email: "support@bisontransport.com"},
    kindersley: {phone: "1-800-000-0008", email: "support@kindersleytransport.com"},
    cvc: {phone: "1-800-000-0009", email: "support@cvcltd.com"},
    "tforce-worldwide": {phone: "1-800-000-0010", email: "support@tforceworldwide.com"},
    medallion: {phone: "1-800-000-0011", email: "support@medallion.com"},
};

const DEFAULT_CARRIER_SUPPORT_CONTACT = {phone: "1-888-000-0000", email: "op@uucargo.ca"};

export const PHASE_MILESTONES = new Set(["In Transit", "Out for Delivery"]);

export const ROUTE_PROGRESS_BY_STATUS = {
    "Label Created": 5,
    "Dispatched": 20,
    "Picked Up": 40,
    "In Transit": 60,
    "Out for Delivery": 80,
    "Delivered": 100,
};

export const getCarrierSupportContact = (carrierName) => {
    if (!carrierName || carrierName === "N/A") return null;

    const carrierKey = Object.keys(CARRIER_SUPPORT_CONTACTS).find(
        (serviceName) => serviceName.toUpperCase() === carrierName.toUpperCase(),
    );
    return carrierKey ? CARRIER_SUPPORT_CONTACTS[carrierKey] : DEFAULT_CARRIER_SUPPORT_CONTACT;
};

export const normalizeTrackingNumber = (value) => value.replace(/\s+/g, "").toUpperCase();
